import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api, getToken } from '../../api.js';
import { useAuth } from '../../auth.jsx';
import { useI18n } from '../../i18n/index.jsx';
import { AuthCard, Alert } from '../../components/ui.jsx';

export default function VerifyEmail() {
  const { t, errorText } = useI18n();
  const { user, refresh } = useAuth();
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: 'pending', error: '' });
  // Tokens are single-use; React's dev double-effect must not spend it twice.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    api('/auth/verify-email', { method: 'POST', body: { token: params.get('token') } })
      .then(() => {
        setState({ status: 'done', error: '' });
        if (getToken()) refresh().catch(() => {});
      })
      .catch((err) => setState({ status: 'error', error: errorText(err) }));
  }, []);

  return (
    <AuthCard title={t('auth.verifyTitle')}>
      {state.status === 'pending' && <p className="muted">{t('auth.verifying')}</p>}
      {state.status === 'error' && <Alert>{state.error}</Alert>}
      {state.status === 'done' && (
        <>
          <Alert kind="success">{t('auth.verifyDone')}</Alert>
          <Link className="btn btn-primary btn-block" to={user ? '/account' : '/login?next=/account'}>{t('auth.verifyGoAccount')}</Link>
        </>
      )}
    </AuthCard>
  );
}
